import React from 'react';
import { Textarea } from '@h2/ui';
import { Field } from '@h2/types';

interface TextareaInputProps {
  field: Field;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const TextareaInput: React.FC<TextareaInputProps> = ({ field, value, onChange, error }) => {
  return (
    <Textarea
      id={field.id}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={field.placeholder}
      className={error ? 'border-red-500' : ''}
      rows={4}
    />
  );
};
